import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LayoutDashboard, ListTodo, Inbox, Trophy, Settings } from 'lucide-react'
import { useAuth } from '@/lib/auth'

// A trimmed subset of the full nav — five items is what fits a bottom
// bar; Time and the Operator-only Activity log stay reachable from the
// desktop header nav only.
const ITEMS = [
  { to: '/', labelKey: 'nav.dashboard', icon: LayoutDashboard, end: true },
  { to: '/tasks', labelKey: 'nav.tasks', icon: ListTodo, end: false },
  { to: '/requests', labelKey: 'nav.requests', icon: Inbox, end: false },
  { to: '/achievements', labelKey: 'nav.achievements', icon: Trophy, end: false },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings, end: false },
] as const

export function MobileNav() {
  const { t } = useTranslation()
  const { user } = useAuth()
  if (!user) return null

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-20 flex justify-around border-t border-line bg-surface sm:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {ITEMS.map(({ to, labelKey, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px] font-semibold ${
              isActive ? 'text-brand' : 'text-ink-soft'
            }`
          }
        >
          <Icon size={18} strokeWidth={2} />
          {t(labelKey)}
        </NavLink>
      ))}
    </nav>
  )
}
